import { render, staticRenderFns } from "./FaultReportForm.vue?vue&type=template&id=1b0909fe&"
import script from "./FaultReportForm.vue?vue&type=script&lang=js&"
export * from "./FaultReportForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports